import { render, staticRenderFns } from "./ShowTopic.vue?vue&type=template&id=4711ba0c&scoped=true"
import script from "./ShowTopic.vue?vue&type=script&lang=js"
export * from "./ShowTopic.vue?vue&type=script&lang=js"
import style0 from "./ShowTopic.vue?vue&type=style&index=0&id=4711ba0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4711ba0c",
  null
  
)

export default component.exports